import {Component, computed, OnInit, input, inject, ChangeDetectionStrategy} from "@angular/core"
import {FiltersService} from "@common/services/filters/filters.service"
import {forceSetValue, setsAreEqual} from "@common/helpers/utils/set"
import {filter, map} from "rxjs"
import {PlaceholderComponent} from "@common/components/placeholders/placeholder/placeholder.component"
import {MaterialColorLabel} from "@app/platform/models/state-labels/material-color-labels"

/**
 * Color filter displayed as clickable colored circles
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-color-circle-filter",
    templateUrl: "./color-circle-filter.component.html",
    styleUrls: ["./color-circle-filter.component.scss"],
    imports: [PlaceholderComponent],
})
export class ColorCircleFilterComponent implements OnInit {
    readonly $label = input("", {alias: "label"})
    readonly $name = input<string>("", {alias: "name"})
    readonly $options = input<MaterialColorLabel[] | Map<string, MaterialColorLabel> | null>(null, {alias: "options"})
    readonly $resolvedOptions = computed<MaterialColorLabel[] | null>(() => {
        const value = this.$options()
        if (value instanceof Map) {
            return Array.from(value.values())
        }
        return value
    })

    public selectedOptions = new Set<string>()

    public onColorToggled = (colorValue: string) => {
        const isSelected = this.selectedOptions.has(colorValue)
        forceSetValue(this.selectedOptions, colorValue, !isSelected)
        void this.filtersService.updateCriteria(this.$name(), this.selectedOptions)
    }

    public isSelected = (colorValue: string): boolean => {
        return this.selectedOptions.has(colorValue)
    }
    private readonly filtersService = inject(FiltersService)

    constructor() {
        this.filtersService.states
            .pipe(
                map((states) => states.criteria[this.$name()]),
                filter((selection) => !setsAreEqual(selection, this.selectedOptions)),
            )
            .subscribe((selection) => {
                this.selectedOptions = selection ?? new Set()
            })
    }

    ngOnInit() {
        this.filtersService.currentStates.criteria[this.$name()]?.forEach((option) => forceSetValue(this.selectedOptions, option, true))
    }
}
